<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.fb_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="fb_date">
            <label class="weui-form-preview__label">{{
              customLabel.fb_date || "申请日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.fb_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fb_type" key="预算类型">
            <label class="weui-form-preview__label">{{
              customLabel.fb_type || "预算类型"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
             {{ form.main.fb_type }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="fb_emname" key="申请人">
            <label class="weui-form-preview__label">{{
              customLabel.fb_emname || "申请人"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              {{ form.main.fb_dpname }} {{ form.main.fb_emname }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="fb_year" key="年份">
            <label class="weui-form-preview__label">{{
              customLabel.fb_year || "年份"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              {{ form.main.fb_year }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="fb_total" key="本年预算总额">
            <label class="weui-form-preview__label">{{
              customLabel.fb_total || "本年预算总额"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon" v-format="'#,##0.00'">
              {{ form.main.fb_total }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="fb_pretotal">
            <label class="weui-form-preview__label">{{
              customLabel.fb_pretotal || "上年预算总额"
            }}</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.fb_pretotal
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fb_growthrate">
            <label class="weui-form-preview__label">{{
              customLabel.fb_growthrate || "实际增长率"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fb_growthrate
            }}%</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.fbd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="fbd_itemname">
              <label class="weui-form-preview__label">{{
                customLabel.fbd_itemname || "费用类型"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fbd_itemname
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fbd_feetype">
              <label class="weui-form-preview__label">{{
                customLabel.fbd_feetype || "费用类别"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fbd_feetype
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fbd_total">
              <label class="weui-form-preview__label">{{
                customLabel.fbd_total || "本年预算总额"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.fbd_total,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fbd_pretotal">
              <label class="weui-form-preview__label">{{
                customLabel.fbd_pretotal || "上年预算总额"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.fbd_pretotal,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fbd_growthrate">
              <label class="weui-form-preview__label">{{
                customLabel.fbd_growthrate || "实际增长率%"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fbd_growthrate
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fbd_amount1" >
              <label class="weui-form-preview__label">{{
                customLabel.fbd_amount1 || "1月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fbd_amount1
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fbd_amount2" >
              <label class="weui-form-preview__label">{{
                customLabel.fbd_amount2 || "2月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fbd_amount2
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fbd_amount3" >
              <label class="weui-form-preview__label">{{
                customLabel.fbd_amount3 || "3月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fbd_amount3
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fbd_amount4" >
              <label class="weui-form-preview__label">{{
                customLabel.fbd_amount4 || "4月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fbd_amount4
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fbd_amount5" >
              <label class="weui-form-preview__label">{{
                customLabel.fbd_amount5 || "5月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fbd_amount5
              }}</span>
            </div>

            <div class="weui-form-preview__item" slot="fbd_amount6" >
              <label class="weui-form-preview__label">{{
                customLabel.fbd_amount6 || "6月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fbd_amount6
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fbd_amount7" >
              <label class="weui-form-preview__label">{{
                customLabel.fbd_amount7 || "7月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fbd_amount7
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fbd_amount8" >
              <label class="weui-form-preview__label">{{
                customLabel.fbd_amount8 || "8月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fbd_amount8
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fbd_amount9" >
              <label class="weui-form-preview__label">{{
                customLabel.fbd_amount9 || "9月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fbd_amount9
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fbd_amount10" >
              <label class="weui-form-preview__label">{{
                customLabel.fbd_amount10 || "10月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fbd_amount10
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fbd_amount11" >
              <label class="weui-form-preview__label">{{
                customLabel.fbd_amount11 || "11月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fbd_amount11
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fbd_amount12" >
              <label class="weui-form-preview__label">{{
                customLabel.fbd_amount12 || "12月"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fbd_amount12
              }}</span>
            </div>
          </custom-layout>
        </div>
      </div>

      <file-list v-model="form.main.fb_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <!-- <router-link
        :to="'/oa/fee_budget_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      > -->
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <!-- <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      > -->
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";


export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
  },
  data() {
    return {
      baseUrl: "/api/oa/feebudget",
      codeField: "fb_code",
      statusField: "fb_statuscode",
      caller: "FeeBudget",
      xtype: "oa-feebudget-formpanel",
    };
  },
  methods: {
    turnFeeChange() {
      const me = this;
      me.$router.push({
        name: "OaFeeApplyTurnEdit",
        params: {
          id: me.form.main.id,
        }
      });
    }
  }
};
</script>